"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var VSteps_1 = require("../../VSteps");
var CheckMark_1 = __importDefault(require("../CheckMark"));
var SRow = (0, styled_components_1.default)('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: ", ";\n"])), function (props) { var _a; return props.isActive ? '#252628' : (_a = props.secondaryColor) !== null && _a !== void 0 ? _a : '#7b7d82'; });
var DescriptionDiv = (0, styled_components_1.default)('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: max-content;\n  font-size: smaller;\n"], ["\n  width: max-content;\n  font-size: smaller;\n"])));
var CircleDiv = (0, styled_components_1.default)('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 30px;\n  width: 30px;\n  line-height: 30px;\n  background-color: ", ";\n  border-radius: 50%;\n  border: solid 1px;\n  border-color: ", ";\n  color: ", ";\n  text-align: center;\n  margin-right: 5px;\n"], ["\n  height: 30px;\n  width: 30px;\n  line-height: 30px;\n  background-color: ", ";\n  border-radius: 50%;\n  border: solid 1px;\n  border-color: ", ";\n  color: ", ";\n  text-align: center;\n  margin-right: 5px;\n"])), function (props) { var _a; return props.isActive ? (_a = props.mainColor) !== null && _a !== void 0 ? _a : '#137cbd' : ''; }, function (props) {
    var _a, _b;
    return props.isDone
        ? (_a = props.mainColor) !== null && _a !== void 0 ? _a : '#137cbd'
        : (_b = props.secondaryColor) !== null && _b !== void 0 ? _b : '#7b7d82';
}, function (props) { var _a; return props.isActive ? '#e9ecf3' : (_a = props.secondaryColor) !== null && _a !== void 0 ? _a : '#7b7d82'; });
var StepsUpperBarNode = function (props) {
    var mainCtx = (0, react_1.useContext)(VSteps_1.MainStepsContext);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SRow, __assign({}, props),
            props.icon ? (props.icon) : (react_1.default.createElement(CircleDiv, __assign({}, props, { mainColor: mainCtx.mainColor, secondaryColor: mainCtx.secondaryColor }), props.isDone ? react_1.default.createElement(CheckMark_1.default, null) : props.index)),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", null, props.title),
                react_1.default.createElement(DescriptionDiv, null, props.description)))));
};
exports.default = StepsUpperBarNode;
var templateObject_1, templateObject_2, templateObject_3;
